export default __webpack_public_path__ + "src/_images/FreeInstall_Icon.svg";